import { render } from "./EditItemForm.vue?vue&type=template&id=06184742&scoped=true"
import script from "./EditItemForm.vue?vue&type=script&lang=js"
export * from "./EditItemForm.vue?vue&type=script&lang=js"

import "./EditItemForm.vue?vue&type=style&index=0&id=06184742&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06184742"]])

export default __exports__